/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetImageTobase64Request = { url: string };

export const GetImageTobase64Request$zodSchema: z.ZodType<
  GetImageTobase64Request
> = z.object({
  url: z.string().describe("需要转换为Base64的、可公开访问的图片URL地址。"),
});

export type GetImageTobase64BadGatewayDetails = {};

export const GetImageTobase64BadGatewayDetails$zodSchema: z.ZodType<
  GetImageTobase64BadGatewayDetails
> = z.object({});

/**
 * 获取图片失败。我们无法从你提供的URL下载图片。请检查该URL是否可以公开访问，以及它是否指向一个有效的图片资源。
 */
export type GetImageTobase64BadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetImageTobase64BadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetImageTobase64BadGatewayResponseBody$zodSchema: z.ZodType<
  GetImageTobase64BadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetImageTobase64BadGatewayDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "获取图片失败。我们无法从你提供的URL下载图片。请检查该URL是否可以公开访问，以及它是否指向一个有效的图片资源。",
);

export type GetImageTobase64BadRequestDetails = {};

export const GetImageTobase64BadRequestDetails$zodSchema: z.ZodType<
  GetImageTobase64BadRequestDetails
> = z.object({});

/**
 * 请求参数错误。请检查你是否提供了 `url` 参数，以及它是否是一个合法的URL格式。
 */
export type GetImageTobase64BadRequestResponseBody = {
  code?: string | undefined;
  details?: GetImageTobase64BadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetImageTobase64BadRequestResponseBody$zodSchema: z.ZodType<
  GetImageTobase64BadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetImageTobase64BadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求参数错误。请检查你是否提供了 `url` 参数，以及它是否是一个合法的URL格式。",
);

/**
 * 转换成功！返回包含Base64编码的JSON对象。
 */
export type GetImageTobase64ResponseBody = {
  base64?: string | undefined;
  msg?: string | undefined;
};

export const GetImageTobase64ResponseBody$zodSchema: z.ZodType<
  GetImageTobase64ResponseBody
> = z.object({
  base64: z.string().optional(),
  msg: z.string().optional(),
}).describe("转换成功！返回包含Base64编码的JSON对象。");

export type GetImageTobase64Response =
  | GetImageTobase64ResponseBody
  | GetImageTobase64BadRequestResponseBody
  | GetImageTobase64BadGatewayResponseBody;

export const GetImageTobase64Response$zodSchema: z.ZodType<
  GetImageTobase64Response
> = z.union([
  z.lazy(() => GetImageTobase64ResponseBody$zodSchema),
  z.lazy(() => GetImageTobase64BadRequestResponseBody$zodSchema),
  z.lazy(() => GetImageTobase64BadGatewayResponseBody$zodSchema),
]);
